<div class="flex">
  <p-toast position="bottom-center" key="uploading" [baseZIndex]="5000">
    <ng-template let-message pTemplate="headless" let-closeFn="closeFn">
      <section class="bg-blue-50 text-blue-600 p-1">
        <div>
          <h3 class="title">
            {{ message.summary }}
          </h3>
          <div>
            <p-progressBar mode="indeterminate" [style]="{ height: '4px' }" />
            <label for="uploading"> Uploading... </label>
          </div>
        </div>
      </section>
    </ng-template>
  </p-toast>
</div>
